import PropTypes from 'prop-types';
import React from 'react';

import { GlobalModals } from '../../constants/AppConstants';
import connectToStores from '../../helpers/connectToStores';
import OrderFare from '../../records/order/Fare';
import Fare from '../../records/Fare';
import OrderTrip from '../../records/order/Trip';
import OrderFulfilment from '../../records/order/Fulfilment';
import Favourite from "../../records/Favourite";
import Smartcard from '../../records/customer/Smartcard';
import User from '../../records/User';
import FavouritesStore from '../../stores/FavouritesStore';
import SmartcardStore from "../../stores/SmartcardStore";
import UserStore from "../../stores/UserStore";
import FeatureFlagStore from "../../stores/FeatureFlagStore";
import ModalActions from '../../actions/ModalActions';
import FavouritesActions from '../../actions/FavouritesActions';
import { FavouritesLimitExceededError } from '../../errors/Favourite';

import FavouriteButton from '../favourites/FavouriteButton';

export class AddFavouriteLink extends React.PureComponent {

    static propTypes = {
        buttonProps: PropTypes.object,
        fare: PropTypes.oneOfType([
            PropTypes.instanceOf(Fare).isRequired,
            PropTypes.instanceOf(OrderFare).isRequired
        ]),
        orderTrip: PropTypes.instanceOf(OrderTrip).isRequired,
        delivery: PropTypes.instanceOf(OrderFulfilment).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        enabled: PropTypes.bool.isRequired,
        favourite: PropTypes.instanceOf(Favourite),
        smartcard: PropTypes.instanceOf(Smartcard),
        context: PropTypes.string,
        preventClickPropagation: PropTypes.bool,
    };

    static defaultProps = {
        favourite: null,
        smartcard: null,
        enabled: false,
        context: ''
    };

    state = {
        loading: false
    };

    _toggleFavourite = async event => {
        const { fare, orderTrip, delivery, user, favourite, context } = this.props;

        this.setState({ loading: true });

        if (this.props.preventClickPropagation) {
            event.stopPropagation();
        }

        try {
            if (!favourite) {
                await FavouritesActions.add(fare, orderTrip, delivery, user, context);
            } else {
                await FavouritesActions.remove(favourite, user, context);
            }
        } catch (err) {
            if (err instanceof FavouritesLimitExceededError) {
                ModalActions.open(GlobalModals.ERROR, {
                    title: 'favourites.error.limit.title',
                    message: 'favourites.error.limit.message'
                });
            } else {
                throw err;
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const {
            buttonProps,
            fare,
            favourite,
            delivery,
            smartcard,
            enabled,
            user
        } = this.props;
        const { loading } = this.state;

        // Check if fare is reorderable, if add to favourites is enabled and if user is logged in
        if (!fare.isReorderable() || !enabled || !user.isLoggedIn()) {
            return null;
        }

        // Check ticket delivery method is smartcard and if user has a valid smartcard
        if (delivery.isSmartcard() && !smartcard) {
            return null;
        }

        return (
            <FavouriteButton
                {...buttonProps}
                favourite={favourite}
                loading={loading}
                onClick={this._toggleFavourite}
            />
        );
    }
}

export default connectToStores([ FavouritesStore, UserStore, SmartcardStore, FeatureFlagStore ],
    (props) => ({
        favourite: FavouritesStore.getFavourite(props.fare, props.orderTrip),
        smartcard: SmartcardStore.getCurrent(),
        user: UserStore.getCurrent(),
        enabled: FeatureFlagStore.get('enableFavouriteTickets') && FeatureFlagStore.get('enableFavouriteTicketChanges')
    }))(AddFavouriteLink);



// WEBPACK FOOTER //
// ./src/components/fares/AddFavouriteLink.js